// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const ratelimitClient = createTypedClient();
export const createRatelimitClient = (config) => createTypedClient(config);
